module.exports = __webpack_public_path__ + "img/red_plus.061716d2.svg";